module.exports = __webpack_public_path__ + "static/media/FiraSans-SemiBoldItalic.2ea63246.ttf";